<template>
    <div class="container-fluid" >
        <div class="row justify-content-between my-3">
            <div class="col"><h4>Хуанли</h4></div>
            <div class="col-auto">
                <button type="button" class="btn btn-success" @click="_addNews">
                    Хуанли нэмэх
                </button>
            </div>
        </div>
      <div class= "row" v-if="announcement!=null && announcement.length>0">
        <div class="col-lg-4" v-for="(q, index) in announcement" v-bind:key="q.id">
            <div class="card-deck">
                <div  class="card shadow mb-4">
                    <div class="card-header py-3">
                        <div class="row justify-content-between">
                            <div class="col col-9">
                                <h4 class="m-0 font-weight-bold text-primary" @click="_goDetail(q.id)" style="cursor:pointer">{{index+1}}.  {{q.title}} </h4>
                            </div>
                            <div class="col col-md-auto" >
                                <i class="fas fa-trash text-danger mr-2" @click="_deleteNews(q)"></i>
                                <router-link :to="{ name: 'ImageAdd', params: { objectPath: 'announcement/'+q.id}}"><i class="fas fa-images   mr-2"></i></router-link>
                                <i class="fas fa-edit" v-on:click.stop="_editNews(q)"></i>
                                
                            </div>
                            <!-- <div class="col col-md-auto"  v-on:click.stop="_deleteSchool(q)">
                                <i class="fas fa-trash"></i>
                            </div> -->
                        </div>
                    </div>
                    <div class="card-body">
                        <p v-if="q.description!=null">{{q.description.substring(0,200)}}...</p>
                        <p v-else style="color:red">Дэлгэрэнгүй мэдээлэл ороогүй байна.</p>
                    </div>  
                </div>
            </div>
        </div>
      </div>
      <!-- Modal -->
      <div class="modal fade" id="schoolModal" tabindex="-1" role="dialog" aria-labelledby="schoolModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="schoolModalLabel">Мэдээ нэмэх</h5>
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <form class="user">
                    <div class="form-group">
                        <label>Гарчиг: </label>
                        <input v-model.trim="object.title" class="form-control" aria-describedby="emailHelp" placeholder="Гарчиг">
                    </div>
                    <div class="form-group">
                        <label>Хаана: </label>
                        <input v-model.trim="object.where" class="form-control"  placeholder="Хаана">
                    </div>
                    <div class="form-group">
                        <label>Хэзээ: </label>
                        <input v-model="object.dateStr" class="form-control" placeholder="Огноо" type="datetime-local">
                    </div>
                    <div class="form-group">
                        <label>Тайлбар: </label>
                        <textarea rows="10" v-model.trim="object.description" class="form-control" id="exampleInputPassword" placeholder="Тайлбар мэдээлэл"/>
                    </div>
                    <div class="form-group">
                        <div class="">
                            <input type="checkbox"  id="publishedCheck" v-model="object.published">
                            <label for="publishedCheck">Нээлттэй<span class="text-info"> /Нээлттэй болгосоноор энэ мэдээллийг оюутнууд харах боломжтой./</span></label>
                    </div>
                    </div>

                    <hr>
                    
                </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
              <button @click="saveNews" type="button" class="btn btn-primary btn-user btn-block" data-dismiss="modal">Xадгалаx</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../../firebaseConfig.js')

    export default {
        data() {
            return {
                announcement:[],
                object:{
                    title:'',
                    description:'',
                    published:false,
                    date:null,
                    where:null,
                    dateStr:null

                }

            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        methods: {

            _getQA(){
                fb.db.collection("announcement").orderBy('createdAt', 'desc').onSnapshot(querySnapshot=> {
                    this.announcement=[];
                    querySnapshot.forEach(doc=> {
                        let object=doc.data();
                        object.id = doc.id;
                        this.announcement.push(object);
                    });
                });
       
                
            },
            _goDetail(schoolId){
                // this.$router.push({ name: 'SchoolDetail', params: { schoolId: schoolId} })
            },
            saveNews(){
                if(this.object!=null && this.object!=null && this.object.title!=''){
                    if(this.object.dateStr!=null && this.object.dateStr!=undefined && this.object.dateStr!=''){ 
                        this.object.date=new Date(this.object.dateStr);
                    }
                    if(this.object.id!=null && this.object.id!=''){
                        fb.db.collection("announcement").doc(this.object.id).update({
                            'title':this.object.title,
                            'description':this.object.description,
                            'published':this.object.published,
                            'where': this.object.where,
                            'modifiedAt':new Date(),
                            'date': this.object.date!=undefined?this.object.date:null,
                            'dateStr': this.object.dateStr!=undefined?this.object.dateStr:null,
                            'modifiedUser': fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                        })
                    }
                    else{
                        this.object.createdAt=new Date();
                        this.object.userId=this.$store.getters.currentUser.uid;
                        this.object.user=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                        fb.db.collection("announcement").doc().set(this.object);
                    }
                    this.object={
                        'title':null,
                        'published': false,
                        'description':null,
                        'where':null,
                        "date":null,
                        "dateStr":null
                    }
                }
                else{
                    alert("Та гарчиг, тайлбараа оруулна уу");
                }
            },
            _editNews(news){
                this.object= Object.assign({}, news);
                $('#schoolModal').modal('toggle');
            },
            _addNews(){
                this.object= {};
                $('#schoolModal').modal('toggle');
            },
            _deleteNews(news){
               var result = confirm("Та "+news.title+" устгах уу?");
                if (result) {
                    fb.db.collection("announcement").doc(news.id).delete();
                }

            }
  
        },
        created() {
            var _this=this;

            this._getQA();
                
        },

        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).fromNow()
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>
